import { PrimeReactStylesFunctionType } from '../types';
import { classNames } from 'primereact/utils';

export const BadgeTailwindThemes = {
  badge: {
    root: ({ props }: PrimeReactStylesFunctionType) => ({
      className: classNames(
        'rounded-full p-0 text-center inline-block',
        'bg-fletchers-green-500 text-white font-bold',
        {
          'bg-fletchers-gray-200': props.severity == 'secondary',
          'bg-teal-400': props.severity == 'success',
          'bg-fletchers-green-100': props.severity == 'info',
          'bg-fletchers-yellow-500 ': props.severity == 'warning',
          'bg-violet-500': props.severity == 'help',
          'bg-fletchers-red-500': props.severity == 'danger',
        },
        {
          'text-[0.5rem] min-w-[1rem] h-[1rem] leading-[1rem]': props.size == 'normal',
          'text-[0.75rem] min-w-[1.25rem] h-[1.25rem] leading-[1.25rem]': props.size == null,
          'text-lg min-w-[2.25rem] h-[2.25rem] leading-[2.25rem]': props.size == 'large',
          'text-2xl min-w-[3rem] h-[3rem] leading-[3rem]': props.size == 'xlarge',
        },
      ),
    }),
  },
};
